export const PROJECTS_TABLE_CONFIG = {
  tableId: 'org-proj',
} as const;

/** Short URL keys for the per-column text filters (deep-link / URL state). */
export const PROJECTS_FILTER_URL_KEYS = {
  name: 'pn',
  repoUrl: 'pru',
} as const;
